export default [
  {
    header: 'SEE'
  },
  {
    title: 'Overview',
    route: 'see-campaign-overview',
    icon: 'OverviewIcon'
  },
  {
    title: 'Media',
    icon: 'MediaIcon',
    children: [
      {
        title: 'Awareness',
        route: 'see-campaign-media-awareness'
      },
      {
        title: 'Consideration',
        route: 'see-campaign-media-consideration'
      },
      {
        title: 'Conversion',
        route: 'see-campaign-media-conversion',
      }
    ]
    
  },
  {
    title: 'Creative',
    icon: 'CreativeIcon',
    route: 'see-campaign-creative'
  },
  {
    title: 'Smart Reports',
    icon: 'SmartReportsIcon',
    route: 'see-smartReports-mediaReports',
  },
]
